'use client';
import { useState, useEffect, useRef, useMemo } from 'react';
import { MoveRight, Search } from 'lucide-react';
// import { useProductData } from '@/app/context/productDataContext';
import SearchList from './сomponents/searchlist';
import { useProductData } from '@/app/hooks/products/useProductData';
import { useParams, useRouter } from 'next/navigation';
import productStore from '@/stores/searchStore';
import stateFilterStore from '@/stores/stateFilterStore';
import { IGNORED_COLUMNS } from '@/app/catalog/[section]/filter/components/filter/components/filter/constants';

export default function SearchBar() {
  const { data: products } = useProductData();
  const [searchInput, setSearchInput] = useState('');
  const resultsRef = useRef<HTMLDivElement | null>(null);
  const router = useRouter();
  const { section } = useParams();
  const handleSearch = () => {
    // Перенаправляем на страницу фильтров вместо страницы поиска
    router.push(`/catalog/${section ? section : 'woman'}/filter`);
    handleClickOutside(new MouseEvent('click'));
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      // Фильтруем продукты по поиску
      const filtered = filterProducts(products?.data || [], searchInput);
      // Сохраняем в store
      productStore.setSearchActive(true);
      productStore.setProducts(filtered);

      // Обрабатываем поля товаров для получения уникальных значений
      productStore.processProductFields();

      // Получаем значения полей
      const fieldValues = productStore.getFieldValues();

      // Преобразуем в формат SelectedFilters для stateFilterStore
      const selectedFilters: { [key: string]: string[] } = {};
      Object.entries(fieldValues)
        .filter(([key]) => !IGNORED_COLUMNS.includes(key)) // Фильтруем игнорируемые поля
        .forEach(([key, values]) => {
          selectedFilters[key] = values.map((value) => String(value));
        });

      // Сохраняем фильтры в stateFilterStore
      stateFilterStore.setFiltersFromSearch(selectedFilters);

      // Переходим на страницу поиска
      handleSearch();
      (event.target as HTMLInputElement).blur();
    }
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
  };

  // Функция для фильтрации товаров по поисковому запросу
  const filterProducts = (productsData: any[], searchQuery: string) => {
    if (!productsData || !Array.isArray(productsData)) {
      return [];
    }

    const query = searchQuery.toLowerCase().trim();
    if (!query) {
      return [];
    }

    let count = 0;
    return productsData.filter((product) => {
      const entries = Object.entries(product);
      const hasMatch = entries.some(([key, value]) => {
        const matches =
          !IGNORED_COLUMNS.includes(key) &&
          value != null &&
          value.toString().toLowerCase().includes(query);
        return matches;
      });

      if (hasMatch && count < 5) {
        count++;
      }
      return hasMatch;
    });
  };

  // Используем useMemo вместо useEffect для вычисления отфильтрованных результатов
  const filteredResults = useMemo(() => {
    return products && products.data
      ? filterProducts(products.data, searchInput)
      : [];
  }, [products, searchInput]);
  const handleClickOutside = (
    event: MouseEvent | TouchEvent | React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (
      resultsRef.current &&
      !resultsRef.current.contains(event.target as Node)
    ) {
      setSearchInput('');
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return (
    <div className={`relative z-[222] flex flex-col items-center py-3.5 pt-24`}>
      <div className="relative w-full">
        <input
          type="text"
          value={searchInput}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          placeholder="Найти"
          className="w-full rounded-3xl border py-2 pl-14 pr-4 text-black"
        />
        <MoveRight
          className="absolute right-5 top-1/2 -translate-y-1/2 transform text-gray-500"
          onClick={handleSearch}
        />
        <Search className="absolute left-5 top-1/2 -translate-y-1/2 transform text-gray-500" />
      </div>
      <div
        className="absolute top-36 z-10 w-full bg-white px-4"
        ref={resultsRef}
      >
        {searchInput.length > 0 && (
          <SearchList data={filteredResults} setSearchInput={setSearchInput} />
        )}
      </div>
    </div>
  );
}
